import { createAction } from 'typesafe-actions';
import * as COMMON from '../constants/Common';

export const setShopId = createAction(
    COMMON.SET_SID,
    (resolve) => (sid) => resolve({ sid })
);

export const setLang = createAction(
    COMMON.SET_LANG,
    (resolve) => (lang) => resolve({ lang })
);

export const savePhone = createAction(
    COMMON.SAVE_PHONE,
    (resolve) => (sid, phone) => resolve({ sid, phone })
);

export const saveMemberId = createAction(
    COMMON.SAVE_MEMBER_ID,
    (resolve) => (memberId, sid) => resolve({ memberId, sid })
)

export const logout = createAction(
    COMMON.LOGOUT,
    (resolve) => (sid) => resolve({ sid })
)